import { createApp, watch, ref } from 'vue';
import { createPinia, storeToRefs } from 'pinia';
import layout from '@/style/layout.scss';
import $ from 'jquery';
import Collapse from 'bootstrap/js/dist/collapse';
import validate from '@global/vendors/jquery.validate.min';

import useMiniCartStore from '@global/stores/useMiniCartStore';
import useAlert from '@global/composable/useAlert';
import useMsg from '@global/composable/useMessage';
import useModalStore from '@global/stores/useModalStore';
import useTextProcessing from '@global/composable/useTextProcessing';
import useAPIHandler from '@global/composable/api/useAxiosAPI';

import NewImage from '@global/components/common/Image/NewImage.vue';
import AlertDialog from '@global/components/common/alert/AlertDialog.vue';
import Message from '@global/components/common/message/Message.vue';
import Modal from '@global/components/common/modal/Modal.vue';

import { fireSearchListEvent } from '@global/gtm/shopList/shopListView';
import fireSearchEvent from '@global/gtm/search';

const pinia = createPinia();
const { alertDialog } = useAlert();
const { messageBox } = useMsg();
const { useAutoSupplement } = useTextProcessing();
const { postNewsletter } = useAPIHandler();

global.$ = require('jquery');

global.jQuery = global.$;

require('sticky-kit/dist/sticky-kit');

const app = createApp({
  components: {
    NewImage,
    AlertDialog,
    Message,
    Modal,
  },
  setup() {
    const miniCartStore = useMiniCartStore();
    const modalStore = useModalStore();
    const { modalName } = storeToRefs(modalStore);
    const hotBlock = ref(false);
    const searchQuery = ref('');
    const burgerSidebar = ref(false);

    const {
      totalCount,
      generalCount,
      refrigerationCount,
      freezingCount,
      temperaturesData,
      dataIsLoad,
      count,
      hotSearch,
      hotLoad,
      isOnlyOneTemp,
    } = storeToRefs(miniCartStore);

    const { getCartInfo, getHotSearch } = miniCartStore;

    watch(hotLoad, (val) => {
      if (val && window.location.pathname.includes('search')) {
        fireSearchListEvent(hotSearch.value);
      }
    });

    function goSearchText() {
      if (searchQuery.value.trim() === '') {
        alertDialog.alert('請輸入關鍵字');
      } else {
        window.location.href = `/search?Keyword=${searchQuery.value}`;
        fireSearchEvent({
          isHotSearch: false,
          keyword: searchQuery.value,
        });
      }
    }

    function goSearch(item) {
      window.location.href = `/search?Keyword=${item}`;
      fireSearchEvent({
        isHotSearch: true,
        keyword: item,
      });
    }

    function spread() {
      hotBlock.value = !hotBlock.value;
    }

    function openBurgerSidebar() {
      burgerSidebar.value = !burgerSidebar.value;
      $('body').toggleClass('lock-page');
    }

    getCartInfo();
    getHotSearch();

    return {
      modalName,
      totalCount,
      refrigerationCount,
      generalCount,
      freezingCount,
      temperaturesData,
      dataIsLoad,
      count,
      hotSearch,
      hotLoad,
      hotBlock,
      isOnlyOneTemp,
      useAutoSupplement,
      searchQuery,
      goSearchText,
      burgerSidebar,
      goSearch,
      spread,
      openBurgerSidebar,
    };
  },
});

app.use(pinia).mount('#app-mini-cart');

// 電子報

const mailValidate = {
  errorClass: 'error-text',
  errorElement: 'span',
  rules: {
    newsletter: {
      required: true,
      email: true,
    },
  },
  messages: {},
  errorPlacement(error, element) {
    element.parent().append(error);
  },
  submitHandler(form) {
    postNewsletter({
      Email: $('.input-newsletter').val(),
    })
      .then((res) => {
        if (res.data.Code === 200) {
          alertDialog.alert(res.data.Message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
$('#form-newsletter-signup').validate(mailValidate);

// 全域方法前後端使用
window.AlertDialog = alertDialog;
window.messageBox = messageBox;
